import { NavLink } from "react-router";
import styles from "../styles/notfound.module.scss";

const NotFound = () => {
  return (
    <div className={styles["menu__no-found"]}>
      <h1 className={styles["menu__no-found-title"]}>404</h1>
      <p className={styles["menu__no-found-subtitle"]}>
        Oops! La página que buscas no existe.
      </p>
      <NavLink to="/" className={styles["menu__no-found-button"]}>
        Volver al inicio
      </NavLink>
    </div>
  );
};

export default NotFound;
